import { create } from 'zustand';

interface UIState {
  sidebarOpen: boolean;
  sidebarCollapsed: boolean;
  taskPanelOpen: boolean;
  selectedTaskId: string | null;
  /**
   * When true, TaskPanel backdrop close is suppressed while an edit-mode attachment
   * upload is in flight or the upload result modal awaits "Continue" (UnifiedTaskEditor).
   */
  taskPanelAttachmentUploadBarrier: boolean;
  searchOpen: boolean;
  createTaskOpen: boolean;
  createTaskPreselectedStatusId: string | null;
  createProjectOpen: boolean;
  createListOpen: boolean;
  createListProjectId: string | null;

  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
  toggleSidebarCollapsed: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;

  openTaskPanel: (taskId: string) => void;
  closeTaskPanel: () => void;
  setTaskPanelAttachmentUploadBarrier: (blocked: boolean) => void;

  setSearchOpen: (open: boolean) => void;
  openCreateTask: (preselectedStatusId?: string) => void;
  closeCreateTask: () => void;
  setCreateProjectOpen: (open: boolean) => void;
  setCreateListOpen: (open: boolean, projectId?: string) => void;
}

export const useUIStore = create<UIState>((set) => ({
  sidebarOpen: true,
  sidebarCollapsed: false,
  taskPanelOpen: false,
  selectedTaskId: null,
  taskPanelAttachmentUploadBarrier: false,
  searchOpen: false,
  createTaskOpen: false,
  createTaskPreselectedStatusId: null,
  createProjectOpen: false,
  createListOpen: false,
  createListProjectId: null,

  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  toggleSidebarCollapsed: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
  setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),

  openTaskPanel: (taskId) => set({ taskPanelOpen: true, selectedTaskId: taskId }),
  closeTaskPanel: () =>
    set({ taskPanelOpen: false, selectedTaskId: null, taskPanelAttachmentUploadBarrier: false }),
  setTaskPanelAttachmentUploadBarrier: (blocked) => set({ taskPanelAttachmentUploadBarrier: blocked }),

  setSearchOpen: (open) => set({ searchOpen: open }),
  openCreateTask: (preselectedStatusId) =>
    set({ createTaskOpen: true, createTaskPreselectedStatusId: preselectedStatusId || null }),
  closeCreateTask: () => set({ createTaskOpen: false, createTaskPreselectedStatusId: null }),
  setCreateProjectOpen: (open) => set({ createProjectOpen: open }),
  setCreateListOpen: (open, projectId) =>
    set({ createListOpen: open, createListProjectId: projectId || null }),
}));
